module.exports = __webpack_public_path__ + "static/media/truck.a4f75bbe.png";